import {
  combineReducers,
} from 'redux-immutable';
import loading from './central/LoadingReducer';
import errors from './central/ErrorReducer';
import resources from './resource/ResourcesReducer';
import admin from './auth/AuthReducer';
import selectedItems from './itemsSelect/ItemsSelectReducer';
import tiers from './tiers/TiersReducer';
import coupons from './coupons/CouponsReducer';
import taxes from './taxes/TaxesReducer';

const rootReducer = combineReducers({
  loading,
  errors,
  resources,
  admin,
  selectedItems,
  tiers,
  coupons,
  taxes,
});

export default rootReducer;
